export default __webpack_public_path__ + "static/media/qrcode_@2x.c69dc3e5.png";